export default "__VITE_ASSET__DYu6A9$j__"